import React from 'react';
import { Backdrop, Fade, Modal as MuiModal } from '@mui/material';

import {
  StyledBody,
  StyledContainer,
  StyledContent,
  StyledFooter,
  StyledHeader,
  StyledIconButton,
} from './styles';
import type { ModalProps } from './types';
export default function Modal({
  children,
  close,
  closeButtonClassName,
  closeButtonCss,
  containerCss = {
    maxWidth: 500,
  },
  contentCss,
  footer,
  header,
  headerCss,
  showClose = true,
  ...props
}: ModalProps): JSX.Element {
  const handleClose = () => {
    close();
  };

  return (
    <MuiModal
      BackdropComponent={Backdrop}
      closeAfterTransition
      onClose={handleClose}
      BackdropProps={{
        timeout: 300,
      }}
      {...props}
    >
      <section>
        <Fade in={props.open}>
          <StyledContainer style={containerCss}>
            <StyledBody>
              {header && (
                <StyledHeader style={headerCss}>{header}</StyledHeader>
              )}

              {header && showClose && (
                <StyledIconButton
                  aria-hidden={!props.open}
                  aria-label="Close Modal"
                  className={closeButtonClassName}
                  icon="close"
                  onClick={handleClose}
                  rank="tertiary"
                  style={closeButtonCss}
                />
              )}

              <StyledContent style={contentCss}>
                {!header && showClose && (
                  <StyledIconButton
                    className={closeButtonClassName}
                    icon="close"
                    onClick={handleClose}
                    rank="tertiary"
                    style={closeButtonCss}
                  />
                )}

                {children}
              </StyledContent>

              {footer && <StyledFooter>{footer}</StyledFooter>}
            </StyledBody>
          </StyledContainer>
        </Fade>
      </section>
    </MuiModal>
  );
}
